/**
 * @namespace components
 */

import React from 'react';
import PropTypes from 'prop-types';

import { miniGazelle } from '../../../helpers';

const getIsAriaHidden = ({ className, currentSlide, slideCount }) => {
    return className.includes('slick-next') ? currentSlide + 1 === slideCount :
           className.includes('slick-prev') ? currentSlide === 0 :
           false;
};

const AccessibleCarouselArrow = props => {
    const print = 1;
    const { i, currentSlide, className, onClick, onArrowClick } = props;

    const ariaLabel = className.includes('slick-next')
        ? 'next-slide'
        : className.includes('slick-prev')
        ? 'previous-slide'
        : `${miniGazelle.label('slide', true)}: ${print}`;

    const handleClick = e => {
        if (onClick) {
            onClick(e);
        }

        if (onArrowClick) {
            onArrowClick();
        }
    };

    const isDisabled = getIsAriaHidden(props);

    return (
        <button
            {...props}
            onClick={handleClick}
            aria-label={ariaLabel}
            aria-disabled={isDisabled}
            disabled={isDisabled}
            tabIndex={isDisabled ? -1 : 0}
        />
    );
};

export default AccessibleCarouselArrow;

AccessibleCarouselArrow.propTypes = {
    i: PropTypes.number.isRequired,
    currentSlide: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
};
